import { render, staticRenderFns } from "./PhBb.vue?vue&type=template&id=57a20800&scoped=true&"
import script from "./PhBb.vue?vue&type=script&lang=js&"
export * from "./PhBb.vue?vue&type=script&lang=js&"
import style0 from "./PhBb.vue?vue&type=style&index=0&id=57a20800&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a20800",
  null
  
)

export default component.exports